import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { DateInput } from '@/kit/DatePickers/DateInput';
import { DateRangeCalendar } from '@/kit/DatePickers/calendar/DateRangeCalendar';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const id = MODAL_IDS.date_range_modal;

export const DateRangeModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

export const Modal = ({ range, setRange }) => {
  const { t } = useTranslation('reports');
  const { closeModal } = useModal();

  const [values, setValues] = useState(range);

  const maxDate = new Date();

  const onApply = () => {
    setRange(values);
    closeModal(id);
  };

  const content = (
    <div className={s.modal}>
      <h1 className="f-article-accent">{t('date_picker.date_range')}</h1>
      <div className={s.content}>
        <div className={s.inputs}>
          <DateInput
            name="date_from"
            value={values[0]}
            onChange={date => setValues([date, values[1]])}
            placeholder="dd.mm.yyyy"
          />
          <DateInput
            name="date_to"
            value={values[1]}
            onChange={date => setValues([values[0], date])}
            placeholder="dd.mm.yyyy"
          />
        </div>
        <div className={s.calendar}>
          <DateRangeCalendar
            range={values}
            maxDate={maxDate}
            doubleView={false}
            onRangeChange={setValues}
          />
        </div>
      </div>
      <div className={s.footer}>
        <button
          type="button"
          className={r.grey_large}
          onClick={() => closeModal(id)}
        >
          {t('report_filters.cancel')}
        </button>
        <button type="button" className={r.black_large} onClick={onApply}>
          {t('report_filters.apply')}
        </button>
      </div>
    </div>
  );

  return (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  );
};
